import React from 'react'
import { useRecordContext, Toolbar, DeleteButton } from 'react-admin'
import { Stack } from '@mui/material'
import {
  BackButton,
  // SaveWithConfirmButton,
  ApproveSaveButton,
  // RevokeApproveButton,
  PublishSaveButton,
  UnpublishButton,
} from '../buttons/index'
import { ApproveAndPublishToolBarType } from './type'
import { isExpire } from '../../utils/form'

const ApproveAndPublishToolBar: React.FC<ApproveAndPublishToolBarType> = ({
  children = null,
  encType,
  leftButtons,
  rightButtons,
}) => {
  const record = useRecordContext()
  const {
    is_approved: IsApproved,
    is_published: isPublished,
    end_date: endDate,
  } = record || {
    is_approved: false,
    is_published: false,
    end_date: null,
  }

  const released = isPublished
  const pendingApprove = !IsApproved
  const readyToPublished = !pendingApprove && !released
  const expired = isExpire(endDate)
  return (
    <Toolbar sx={{ justifyContent: 'space-between', py: 1.5 }}>
      <Stack flexGrow={1} spacing={1}>
        <Stack direction='row' justifyContent='space-between'>
          <Stack direction='row' gap={2}>
            {record && !IsApproved ? <DeleteButton size='medium' /> : <BackButton />}
            {leftButtons}
          </Stack>
          <Stack direction='row' justifyContent='space-between' gap={2}>
            {rightButtons}
            {((record && pendingApprove) || !record) && (
              <>
                {/* <SaveWithConfirmButton encType={encType} /> */}
                <ApproveSaveButton encType={encType} />
              </>
            )}
            {record && readyToPublished && (
              <>
                {/* <RevokeApproveButton encType={encType} /> */}
                <ApproveSaveButton encType={encType} />
                <PublishSaveButton encType={encType} disabled={expired} />
              </>
            )}
            {record && released && (
              <>
                {/* <RevokeApproveButton encType={encType} /> */}
                <UnpublishButton encType={encType} />
              </>
            )}
          </Stack>
        </Stack>
        {children}
      </Stack>
    </Toolbar>
  )
}

export default ApproveAndPublishToolBar
